import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=530e3484&scoped=true"
import script from "./VideoDialog.vue?vue&type=script&lang=js"
export * from "./VideoDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoDialog.vue?vue&type=style&index=0&id=530e3484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530e3484",
  null
  
)

export default component.exports